/**
 * PURPOSE: Servicios para compañías / empresas.
 * RESPONSIBILITIES: Consumir endpoints de compañías y permisos de compañías para Winscore.
 * COLLABORATORS: src/pages/Companies.jsx, src/sections/CampeonatosSection.jsx, src/admin/CreateUser/Modal/ModalUpdatePermisosCompany/ModalUpdatePermisosCompany.jsx
 * ROUTE: src/services/company.js
 */
import httpService from "./httpService.js";

export async function getCompanies() {
  return httpService.get("/companies").then((response) => {
    const data = response?.data;
    return Array.isArray(data) ? data : [];
  });
}

export async function getCompany(idcompany) {
  return httpService
    .get("/company", { params: { idcompany } })
    .then((response) => response?.data || null);
}

export async function getMenuCompanies({ iduser }) {
  return httpService.post("/menu_companies", { iduser }).then((response) => {
    const data = response?.data;
    return Array.isArray(data) ? data : [];
  });
}

export async function createMenuCompany({ iduser, idcompany }) {
  return httpService
    .post("/menu_create_company", { iduser, idcompany })
    .then((response) => response?.data);
}

export async function deleteMenuCompany({ iduser, idcompany }) {
  return httpService
    .delete("/menu_delete_company", { data: { iduser, idcompany } })
    .then((response) => response?.data);
}
